// Interpolate between soft pink, peach, green, blue, lavender, and rose.
const pastelColors = [
  [250, 224, 224],
  [250, 240, 214],
  [222, 242, 224],
  [219, 239, 245],
  [228, 227, 248],
  [244, 225, 241],
];

const nameHashBase = 31;
const goldenRatioMultiplier = 0x9e3779b9;

// Accept an optional #RRGGBB/RRGGBB override. Invalid optional colors use the
// stable hash so a malformed database color cannot prevent a product download.
export function getFarmSpreadsheetColor(farmName, farmColor) {
  if (typeof farmColor === "string") {
    const rgb = farmColor.trim().replace(/^#/, "");
    if (/^[0-9a-f]{6}$/i.test(rgb)) {
      return `FF${rgb.toUpperCase()}`;
    }
  }

  const name = farmName
    .normalize("NFKC")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
  let hash = 0;
  for (const character of name) {
    hash = Math.imul(hash, nameHashBase) + character.codePointAt(0);
  }

  // Use only the name, so filtering, sorting, or adding farms never changes it.
  // Hashes can yield similar colors; the Farmer column remains the identifier.
  // A one-character suffix step (Farm A → Farm B) moves about 137.5 degrees
  // around the palette, rather than landing on an almost identical tint.
  const colorHash = Math.imul(hash, goldenRatioMultiplier) >>> 0;
  const position = (colorHash / 2 ** 32) * pastelColors.length;
  const index = Math.floor(position);
  const blend = position - index;
  const nextColor = pastelColors[(index + 1) % pastelColors.length];
  const channels = pastelColors[index].map((channel, channelIndex) =>
    Math.round(channel + (nextColor[channelIndex] - channel) * blend)
      .toString(16)
      .padStart(2, "0"),
  );
  // Excel fills use opaque ARGB: light RGB tints preserve the pastel appearance.
  return `FF${channels.join("")}`.toUpperCase();
}
